module.exports = __webpack_public_path__ + "img/hest11.65d27941.jpg";